import { useCallback, useEffect, useState } from "react";
import httpService from "V2.0/services/httpService";
import { showErrorToast } from "V2.0/utils";

function useAgentAssignedConversation(
  selectedConversation,
  isConversationActive,
  refreshConversations
) {
  const [agentAssignedConversation, setAgentAssignedConversation] = useState(
    selectedConversation || {}
  );
  const [assignAgent, setAssignAgent] = useState({
    isOpen: false,
    mode: "",
  });

  useEffect(() => {
    setAgentAssignedConversation(selectedConversation);
  }, [selectedConversation]);

  const fetchAssignedConversationById = async (projectId, conversationId) => {
    try {
      const response = await httpService.get(
        `/conversation/whitelabelGetConversation/${projectId}/${conversationId}`
      );
      if (response.status === 200) {
        setAgentAssignedConversation(response.data);
      }
    } catch (e) {
      showErrorToast(e, "Failed to get conversation")
    }
  };

  function updateLocalMessage(message) {
    setAgentAssignedConversation((prevState) => {
      const messages = [...prevState.messages];

      return {
        ...prevState,
        messages: [
          ...messages,
          {
            q: " ",
            a: message,
            aTimestamp: new Date().getTime(),
          },
        ],
      };
    });
  }

  const listener = useCallback(
    (event) => {
      fetchAssignedConversationById(
        selectedConversation?.workspace,
        selectedConversation._id
      );
    },
    [selectedConversation]
  );

  const agentId =
    agentAssignedConversation?.humanAgentAssignmentSettings?.humanAgentAssigned
      ?._id;

  return {
    agentAssignedConversation,
    assignAgent,
    setAssignAgent,
    agentId,
    updateLocalMessage,
    listener,
    fetchAssignedConversationById,
  };
}

export default useAgentAssignedConversation;